// Import Packages
import React, { useState, useEffect, useRef } from "react";
import { useRecoilState, useSetRecoilState } from "recoil";

// Import Material UI
import SquareBrackets from '../../../../../../../assets/icons/JsonPreviewIcons/SquareBrackets';
import CurlyBrackets from '../../../../../../../assets/icons/JsonPreviewIcons/CurlyBrackets';
import EventAvailableIcon from '@material-ui/icons/EventAvailable';
import TextFormatIcon from '@material-ui/icons/TextFormat';
import LooksOneIcon from '@material-ui/icons/LooksOne';
import Button from '@material-ui/core/Button';
import EditAttributesIcon from '@material-ui/icons/EditAttributes';
import ListIcon from '@material-ui/icons/List';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import Tooltip from "@material-ui/core/Tooltip";
import { CircularProgress } from "@material-ui/core";

// Import Pages
//import { selectedField } from '../../../../../../../recoil-store/recoil-state';
import ArrayField from '../arrayField/ArrayField'

// Import CSS
import './objectField.css';
import HTMLReactParser from "html-react-parser";
import * as helper from "../../../../../../../helpers/helper";

const ObjectField = ({
    disabledFields,
    fieldLoading,
    fp_details,
    selectField,
    data,
    path,
    root,
    names,
    hasParent,
    searchText,
    disableInputs,
    foundFields
}) => {
    //const setSelectedField = useSetRecoilState(selectedField);

    const [collapse, setCollapse] = useState(false);
    const [hover, setHover] = useState(false);


    useEffect(() => {
        if (root && !path) {
            setCollapse(true);
        }
        // setSelectedField(f => ({
        //     ...f,
        //     name: '',
        //     type: '',
        //     path: []
        // }))
        // setCollapse(false);
    }, []);


    const toggleHover = () => {
        setHover(!hover)
    }

    // const selectField = (name, type, path) => {
    //     name = names[name] ? names[name] : name;
    //     setSelectedField(f => ({
    //         ...f,
    //         name,
    //         type,
    //         path: `##${path}##`
    //     }))
    // }

    const getIndicesOf = (searchStr, str, caseSensitive) => {
        let searchStrLen = searchStr ? searchStr.length : 0;
        if (searchStrLen === 0) {
            return [];
        }
        let startIndex = 0, index, indices = [];
        if (!caseSensitive) {
            str = str.toLowerCase();
            searchStr = searchStr.toLowerCase();
        }
        while ((index = str.indexOf(searchStr, startIndex)) > -1) {
            indices.push(index);
            startIndex = index + searchStrLen;
        }
        return indices;
    }

    return (data &&
        <>
            {
                root && Object.keys(data).length > 0 && (searchText.length < 2 || foundFields[path]) && (
                    <div onClick={() => setCollapse(!collapse)} onMouseEnter={toggleHover} onMouseLeave={toggleHover}
                        className={`collapse-button ${hover ? 'hover' : ''}`}>
                        <button className="button"><span
                            className={collapse ? 'plus' : 'minus'}>{collapse ? '+' : '-'}</span></button>
                    </div>
                )
            }
            <span>
                <div
                    className={`${(!root || searchText.length < 2 || foundFields[path]) ? 'left10' : ''} display-${collapse ? 'none' : 'block'}`}>
                    {
                        Object.keys(data).map((keyName, i) => {
                            let type;
                            if (helper.checkIsDate(data[keyName])) {
                                type = "date";
                            } else {
                                type = typeof data[keyName];
                            }

                            let keyPath = path;
                            keyPath += root && keyPath ? `[${keyName}]` : keyName;
                            // let keyPath = Array.from(path);
                            // keyPath.push(keyName)
                            let displayName = names && names[keyName] ? names[keyName] : keyName;

                            String.prototype.replaceBetween = function (start, end, what) {
                                return this.substring(0, start) + what + this.substring(end);
                            };

                            const indices = getIndicesOf(searchText, displayName);

                            if (displayName?.toLowerCase().includes(searchText?.toLowerCase())) {
                                // indices.map((v, i) => {

                                // })
                                for (let i = indices.length - 1; i >= 0; i--) {
                                    const firstIndex = indices[i];
                                    const lastIndex = indices[i] + searchText.length;
                                    let newText = displayName.substring(firstIndex, lastIndex);
                                    displayName = displayName.replaceBetween(firstIndex, lastIndex, `<span class='highlighted' id='highlighted-${i}'>${newText}</span>`)
                                }
                            }
                            let isDisabled = false;
                            if (disableInputs) {
                                const input = disableInputs.find(x => x.name === keyName);
                                if (input) {
                                    isDisabled = input.type === type
                                }
                            }

                            if (Array.isArray(data[keyName])) {
                                if (data[keyName].length > 0) {
                                    return (
                                        <div>
                                            {
                                                (searchText.length < 2 || foundFields[keyPath]) &&
                                                <span className="p-relative">
                                                    <Tooltip title={keyName} placement="right-end" enterNextDelay={600} leaveDelay={0}
                                                        PopperProps={{
                                                            disablePortal: true,
                                                        }}>
                                                        <span className="p-relative">
                                                            <Button
                                                                disabled={(isDisabled || disabledFields && disabledFields[keyPath]) || fieldLoading}
                                                                onClick={() => selectField(keyName, type, keyPath)}
                                                                // className="expandable-button field-preview-button"
                                                                className={`field-preview-button ${isDisabled || disabledFields && disabledFields[keyPath] ? '' : 'data-manager-button'} max-w-100`}
                                                                variant="contained"
                                                                size="small"
                                                                startIcon={<ListIcon />}
                                                            >
                                                                <span className="field-preview-item-name">
                                                                    {HTMLReactParser(displayName)}
                                                                </span>
                                                            </Button>
                                                        </span>
                                                    </Tooltip>
                                                    {fieldLoading === keyPath ? <CircularProgress size={20} style={{ position: "absolute", left: "-25px", top: "10px" }} /> : ""}
                                                </span>
                                            }
                                            <ArrayField data={data[keyName]} keyPath={keyPath} names={names} type={type}
                                                hasParent={true} selectField={selectField} fieldLoading={fieldLoading}
                                                fp_details={fp_details} disabledFields={disabledFields}
                                                disableInputs={disableInputs} searchText={searchText}
                                                foundFields={foundFields} />
                                        </div>
                                    )
                                } else {

                                    return (searchText.length < 2 || foundFields[keyPath]) ? (
                                        <div className="padding-empty-array p-relative">
                                            <Tooltip title={keyName} placement="right-end" enterNextDelay={600} leaveDelay={0}
                                                PopperProps={{
                                                    disablePortal: true,
                                                }}>
                                                <span>
                                                    <Button
                                                        // disabled={true}
                                                        disabled={(isDisabled || disabledFields && disabledFields[keyPath]) || fieldLoading}
                                                        onClick={() => selectField(keyName, type, keyPath)}
                                                        // className="expandable-button field-preview-button"
                                                        className={`field-preview-button ${isDisabled || disabledFields && disabledFields[keyPath] ? '' : 'data-manager-button'} max-w-100`}
                                                        variant="contained"
                                                        size="small"
                                                        startIcon={<SquareBrackets />}
                                                    >
                                                        <span className="field-preview-item-name">
                                                            {HTMLReactParser(displayName)}
                                                        </span>
                                                    </Button>
                                                </span>
                                            </Tooltip>
                                            {fieldLoading === keyPath ? <CircularProgress size={20} style={{ position: "absolute", left: "-25px", top: "10px" }} /> : ""}
                                        </div>
                                    ) : null
                                }
                            } else if (type === 'object' && data[keyName]) {
                                return (
                                    <div>
                                        {
                                            (searchText.length < 2 || foundFields[keyPath]) &&
                                            <span className="p-relative">
                                                <Tooltip title={keyName} placement="right-end" enterNextDelay={600} leaveDelay={0}
                                                    PopperProps={{
                                                        disablePortal: true,
                                                    }}>
                                                    <span className="p-relative">
                                                        <Button
                                                            // disabled={true}
                                                            // className="expandable-button field-preview-button"
                                                            disabled={(isDisabled || disabledFields && disabledFields[keyPath]) || fieldLoading}
                                                            onClick={() => selectField(keyName, type, keyPath)}
                                                            className={`field-preview-button ${isDisabled || disabledFields && disabledFields[keyPath] ? '' : 'data-manager-button'} max-w-100`}
                                                            variant="contained"
                                                            size="small"
                                                            startIcon={<CurlyBrackets />}
                                                        >
                                                            <span className="field-preview-item-name">
                                                                {HTMLReactParser(displayName)}
                                                            </span>
                                                        </Button>
                                                    </span>
                                                </Tooltip>
                                                {fieldLoading === keyPath ? <CircularProgress size={20} style={{ position: "absolute", left: "-25px", top: "0" }} /> : ""}
                                            </span>
                                        }

                                        <ObjectField disabledFields={disabledFields} selectField={selectField} fieldLoading={fieldLoading}
                                            data={data[keyName]} names={names} searchText={searchText}
                                            path={keyPath} hasParent={true} root={true}
                                            fp_details={fp_details} disableInputs={disableInputs}
                                            foundFields={foundFields} />

                                    </div>
                                )

                            } else {

                                const getIcon = () => {
                                    switch (type) {
                                        case 'string':
                                            return <TextFormatIcon />
                                        case 'number':
                                            return <LooksOneIcon />
                                        case 'object':
                                            return <CurlyBrackets />
                                        case 'boolean':
                                            return <EditAttributesIcon />
                                        case 'date':
                                            return <EventAvailableIcon />
                                        default:
                                            return <EditAttributesIcon />
                                    }
                                }
                                return (searchText.length < 2 || foundFields[keyPath]) ? (
                                    < div className="padding-top-5 p-relative">
                                        <Tooltip title={keyName} placement="right-end" enterNextDelay={300} leaveDelay={0}
                                            PopperProps={{
                                                disablePortal: true,
                                            }}>
                                            <Button
                                                disabled={(isDisabled || disabledFields && disabledFields[keyPath]) || fieldLoading} //|| fp_details && fp_details[keyName] )}// fp_details[keyName].key && disabledFields[`${keyPath}[${fp_details[keyName].key}]`])}
                                                onClick={() => selectField(keyName, type, keyPath)}
                                                variant="contained"
                                                className={`field-preview-button ${isDisabled || disabledFields && disabledFields[keyPath] ? '' : 'data-manager-button'} max-w-100`}
                                                size="small"
                                                startIcon={getIcon()}
                                            >
                                                <span className="field-preview-item-name">{HTMLReactParser(displayName)}</span>
                                            </Button>
                                        </Tooltip>
                                        {fieldLoading === keyPath ? <CircularProgress size={20} style={{ position: "absolute", left: "-25px", top: "10px" }} /> : ""}
                                    </div>
                                ) : null
                            }
                        })
                    }

                </div>
            </span >
        </>
    )
}

export default ObjectField;
